<template>

	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<div style="overflow-y:auto !important; overflow-x: hidden; height: 90vh;">
			<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
				<!-- 			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.deviceNum" :placeholder="$tt('设备编号/IMEI/MAC')" >
						<span slot="prepend">{{$tt('充电站')}}</span>
					</Input>
			</FormItem> -->
				<FormItem prop="trackName" :label="$tt('运营商:')" :label-width="80">
					<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
						<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
						<!-- <span slot="prepend">{{$tt('联系电话')}}</span> -->
					</Select>
				</FormItem>
				<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="80">
					<Select filterable style="width: 120px;" v-model="formInline.StationId">
						<Option :value="0">{{$tt('全部')}}</Option>
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
						<!-- <span slot="prepend">{{$tt('联系电话')}}</span> -->
					</Select>
				</FormItem>
				<FormItem prop="trackName" :label="$tt('设备编号:')" :label-width="100">
					<Input type="text" style="width: 120px;" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')" />
				</FormItem>
				<FormItem prop="trackName" :label="$tt('设备序列号:')" :label-width="100">
					<Input type="text" style="width: 120px;" v-model="formInline.EquipmentSerialNo" :placeholder="$tt('设备序列号')" />
				</FormItem>
				<FormItem v-if='Control.select'>
					<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
				</FormItem>
			</Form>
			<Card style="margin-bottom: 20px;box-shadow: 2px 2px 4px #a7a7a7;width: calc(100% - 5px);background-color: white;">
				<Row>
					<Col span="6">
					<Tag color="#7265e6" type="dot" size="large" style="font-size: 18px;">{{$tt('总数量')}}{{Summary.Total}}</Tag>
					</Col>
					<Col span="6">
					<Tag color="primary" type="dot" size="large" style="font-size: 18px;">{{$tt('充电')}}{{Summary.Charging}}</Tag>
					</Col>
					<Col span="6">
					<Tag color="success" type="dot" size="large" style="font-size: 18px;">{{$tt('待机')}}{{Summary.Standby}}</Tag>
					</Col>
					<!-- <Col span="5">
					<Tag color="#bbbbbb" type="dot" size="large" style="font-size: 18px;">{{$tt('离线')}}{{Summary.Offline}}</Tag>
					</Col> -->
					<Col span="6">
					<Tag color="#ed4e4c" type="dot" size="large" style="font-size: 18px;">{{$tt('故障')}}{{Summary.Alarming}}</Tag>
					</Col>
				</Row>
			</Card>
			<div v-for="(statusItem, idx) in statusList" :key="idx" style="margin-bottom: 20px; text-align: left;">
					<Tag slot="title" class="label" :color="statusItem.color" type="dot">{{$tt(statusItem.statusDesc)}}</Tag>
					<Row :gutter="12" type="flex" justify="start" class="chargeCardClass">
						<Col class="col-24 col-md-12 col-lg-8 col-xxl-6 col-xxl-5 col-xxl-4" v-bind:key="index"
							v-for="(item, index) in statusItem.statusData">
						<Card :class="titleColor(item.WorkStatus)">
							<p slot="title">
								<!-- <span class="tag" style="font-size: 0.46875rem;">{{item.ConnectorType!=3?'交':'直'}}</span> -->
								<span class="1" style="font-size: 1rem;">{{item.ConnectorType==4?'DC |':'AC |'}}</span>
								<span style="font-size: 1rem;">
									{{item.ConnectorNo}}{{item.EquipmentSerialNo ?'/':''}}{{item.EquipmentSerialNo}}</span>
							</p>
							<a style="color: #000000;font-size: 0.75rem;" href="#" slot="extra"
								@click.prevent="detail(item.ConnectorNo,item.WorkStatus)">
								<!-- <Icon type="ios-loop-strong"></Icon> -->
								<Icon type="ios-browsers-outline" size="24" color="white" />
							</a>
							<div class="freeDiv">
								<div class="cicle_p circle-div">
									<i-circle :percent="100" :size="72" :stroke-color="circleColor(item.WorkStatus)" :stroke-width="8"
										:trail-width="8">
										<!-- 圆形空间小：显示短写、字号按长度自适应，鼠标悬停用 title 看完整状态 -->
										<p :style="circleTextStyle(item)" :title="workStatusFull(item)">
											{{workStatusShort(item)}}
										</p>
										<p v-if="item.ConnectorType==4" style="font-size:1rem;margin-top: 12px;">
											{{item.CurrentSoc}}%
										</p>
									</i-circle>
								</div>
								<div class="statusCard">
									<div v-if="item.WorkStatus == 2">
										<!-- <Col span="24"> -->
										<Row style="margin-bottom: 8px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{$tt('电压:')}}
											</span>
											<span>{{item.ChargeVoltage}} V</span>
											</Col>
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{$tt('电流:')}}
											</span>
											<span>
												{{item.ChargeCurrent}} A
											</span>
											</Col>
										<!-- </Row> -->
										<!-- <Row style="margin-bottom: 8px;text-align: left;"> -->
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{$tt('时长:')}}
											</span>
											<span>
												{{item.ChargeDurationDesc}}
											</span>
											</Col>
											<!-- <Col span="12" v-if="item.ConnectorType!=3">
												<span>
													<Icon type="ios-pricetag" size="15" />{{$tt('实时功率:')}}
												</span>
												<span>
													{{item.CurrentSoc}}kW
												</span>
												</Col> -->
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{$tt('功率:')}}
											</span>
											<span>
												{{item.ChargePower.toFixed(2)}} kW
											</span>
											</Col>
										<!-- </Row> -->
										<!-- <Row style="margin-bottom: 8px;text-align: left;"> -->
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{$tt('电量:')}}
											</span>
											<span>
												{{item.ChargeKwh}} kWh
											</span>
											</Col>
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{$tt('金额:')}}
											</span>
											<span>
												¥{{item.ChargeCost}} 
											</span>
											</Col>
										</Row>
										<!-- </Col> -->
									</div>
									<div v-else>
										<!-- <Col span="24"> -->
										<Row style="text-align: left;" v-if="item.WorkStatus==6">
											<Col span="24">
											<span>
												{{$tt('告警描述：')}}
											</span>
											<span>
												<!-- 按告警码取字典（define_alarm_code.xlsx），取不到时退回后端描述 -->
												{{$tAlarm(item.MaxAlarmCode, item.MaxAlarmDesc)}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==0">
											<Col span="24">
											<span>
												{{$tt('插枪状态：')}}
											</span>
											<span>
												{{$tEnum('CarCoupleStatus', item.CarCoupleStatus, item.CarCoupleStatusDesc)}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==3">
											<Col span="24">
											<span>
												{{$tt('插枪状态：')}}
											</span>
											<span>
												{{$tEnum('CarCoupleStatus', item.CarCoupleStatus, item.CarCoupleStatusDesc)}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==-1">
											<Col span="24">
											<span>
												{{$tt('离线时间：')}}
											</span>
											<span>
												{{item.OfflineTime}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else>
											<Col span="24">
											<span>
												{{$tt('插枪状态：')}}
											</span>
											<span>
												{{$tEnum('CarCoupleStatus', item.CarCoupleStatus, item.CarCoupleStatusDesc)}}
											</span>
											</Col>
										</Row>
										<!-- </Col> -->
									</div>
								</div>
							</div>
						</Card>
						</Col>
					</Row>
					<Button type="dashed" long v-on:click="showMore(idx)"
						:disabled="isAllShowed(idx)">{{ statusItem.statusData.length == statusItem.statusDataTotal.length ? $tt('已加载全部') : $tt('加载更多') }}
					</Button>
				</div>
			
			<Modal v-model="showModel" :title="$tt('设备状态详情')" width="80%">
				<Tabs value="name1">
					<TabPane :label="$tt('设备状态')" name="name1">
						<Table :columns="columns1" :data="dataDetail" ref="table" size="small"></Table>
					</TabPane>
					<TabPane :label="$tt('订单情况')" name="name2">
						<Table :columns="columns2" :data="dataDetail" v-if="tableShow" ref="table2" size="small"></Table>
					</TabPane>
				</Tabs>
			</Modal>
			<!-- <MyPage ref="sonPage" :param="pageParam" :url="getEqumentStatusBaseUrl" @listData='getDeviceData'></MyPage> -->
		</div>
	</div>
</template>

<script>
	// import echarts1 from "../../../js/echarts_hot.js";
	// import dateFormat from '../../../../public/js/comm.js'
	// import Qs from 'qs'
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';

	export default {
		data() {
			//自定义表单验证
			// const latlng = (rule, value, callback) => {
			// 	var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;

			// 	if (!latreg.test(value)) {
			// 		callback(new Error("请填写正确经纬度格式"));
			// 	} else {
			// 		callback();
			// 	}
			// };
			return {
				getEqumentStatusBaseUrl: webapi.base_api_url + '/Operations/GetEqumentStatusBase',
				Control: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//详情model
				showModel: false,
				//model中两个table显示
				tableShow: true,
				tableHeight: "650",
				//充电设备总计
				Summary: {
					Total: 0,
					Charging: 0,
					Standby: 0,
					Offline: 0,
					Alarming: 0,
				},
				BreadcrumbList: [this.$tt('场站监控'), '>>', this.$tt('设备状态')],
				formInline: {
					OperatorId: '',
					StationId: 0,
					EquipmentNo: '',
					EquipmentSerialNo: '',
				},
				//table1标题数据
				columns1: [{
						title: this.$tt('设备编号'),
						key: 'EquipmentNo',
					},
					// {
					// 	title: '设备名称',
					// 	key: 'EquipmentName',
					// },
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo'
					},
					// {
					// 	title: '枪名称',
					// 	key: 'ConnectorName'
					// },
					{
						title: this.$tt('设备类型'),
						key: 'EquipmentType',
						render: (h, params) => {
							let type = ''
							switch (params.row.EquipmentType) {
								case 1:
									type = "直流设备"
									break;
								case 2:
									type = "交流设备"
									break;
								case 3:
									type = "交直流一体设备"
									break;
								case 4:
									type = "无线设备"
									break;
								default:
									type = "其他"
									break;
							}
							return h('div',
								type
							);
						}
					},
					// {
					// 	title: '枪类型',
					// 	key: 'ConnectorType',
					// 	render: (h, params) => {
					// 		let type = ''
					// 		switch (params.row.ConnectorType) {
					// 			case 1:
					// 				type = "家用插座（模式2）"
					// 				break;
					// 			case 2:
					// 				type = "交流接口插座（模式3，连接方式B ）"
					// 				break;
					// 			case 3:
					// 				type = "交流接口插头（带枪线，模式3，连接方式C）"
					// 				break;
					// 			case 4:
					// 				type = "直流接口插头（带枪线，模式4）"
					// 				break;
					// 			case 5:
					// 				type = "大功率交流接口插头"
					// 				break;
					// 			default:
					// 				type = "其他"
					// 				break;
					// 		}
					// 		return h('div',
					// 			type
					// 		);
					// 	}
					// },
					{
						title: this.$tt('工作状态'),
						key: 'WorkStatus',
						render: (h, params) => {
							let type = ''
							switch (params.row.WorkStatus) {
								case 0:
									type = "空闲"
									break;
								case 1:
									type = "充电启动中"
									break;
								case 2:
									type = "充电中"
									break;
								case 6:
									type = "故障"
									break;
								case -1:
									type = "离线"
									break;
								default:
									type = "其他"
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: this.$tt('最高告警码'),
						key: 'MaxAlarmCode',
						render: (h, params) => {
							let color = ''
							switch (params.row.MaxAlarmCode) {
								case 0:
									color = "success"
									break;
								default:
									color = "error"
									break;
							}
							// 按告警码取字典（define_alarm_code.xlsx）；0 对应「无告警」，取不到时退回后端描述
							const type = this.$tAlarm(params.row.MaxAlarmCode, params.row.MaxAlarmDesc)
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: this.$tt('连接状态'),
						key: 'CarCoupleStatus',
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "error",
										type = "未连接"
									break;
								default:
									color = "success",
										type = "已连接"
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					// {
					// 	title: '额定功率',
					// 	key: 'RatedPower'
					// },
					{
						title: this.$tt('站点名称'),
						key: 'StationName'
					}
				],
				//table2标题数据
				columns2: [{
						title: this.$tt('充电订单号'),
						key: 'OrderNo',
						width: 260
					}, {
						title: this.$tt('充电开始时间'),
						key: 'ChargeStartTime',
						width: 160
					},
					{
						title: this.$tt('充电启动方式'),
						key: 'StartModeDesc',
						width: 110
					},
					{
						title: this.$tt('充电电压'),
						key: 'ChargeVoltage',
						width: 110
					},
					{
						title: this.$tt('充电电流'),
						key: 'ChargeCurrent',
						width: 110
					},
					{
						title: this.$tt('充电时长'),
						key: 'ChargeDuration',
						width: 110,
						render: (h, params) => {
							return h('div',
								params.row.ChargeDurationDesc
							);
						}
					},
					{
						title: this.$tt('充电功率'),
						key: 'ChargePower',
						width: 110,
					},
					{
						title: this.$tt('已充电量'),
						key: 'ChargeKwh',
						width: 110,
					},
					{
						title: this.$tt('已充费用'),
						key: 'ChargeCost',
						width: 110,
					},
					{
						title: this.$tt('当前SOC'),
						key: 'CurrentSoc',
						width: 110,
					},
					{
						title: this.$tt('剩余时长'),
						key: 'StationName',
						width: 110,
						render: (h, params) => {
							return h('div',
								params.row.RemainDurationDesc
							);
						}
					},
					{
						title: this.$tt('充电卡编号'),
						key: 'CardNo',
						width: 270
					},
					// {
					// 	title: '手机号码',
					// 	key: 'MemberPhone',
					// 	width: 110,
					// },
					// {
					// 	title: '会员名称',
					// 	key: 'MemberName',
					// 	width: 110,
					// },
					{
						title: this.$tt('电池温度'),
						key: 'BatteryTemp',
						width: 110,
					},
					{
						title: this.$tt('枪温度'),
						key: 'ConnectorTemp',
						width: 110,
					},
					{
						title: this.$tt('汽车VIN码'),
						key: 'VIN',
						width: 110,
					}
				],
				dataCharging: [],
				dataStandby: [],
				dataFault: [],
				dataOffline: [],
				dataDetail: [],
				statusList: [{
					statusDesc: '充电',
					color: '#2d8cf0',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '空闲',
					color: '#19be6b',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '故障',
					color: '#ed4e4c',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: '离线',
					color: '#aaaaaa',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}],
				timer: ''
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
		},
		activated() {
			let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			this.Control = col.control
			// console.log(col.control);
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		updated() {},
		mounted() {
			const _this = this;
			this.$nextTick(function() {
				// 仅在整个视图都被渲染之后才会运行的代码
				// setTimeout(() => {
				// 	if (_this.StationList) _this.formInline.StationId = _this.StationList[0].StationId;
				_this.handleSubmit();
				// }, 1000);
			})
			//_this.getButton()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		computed: {
			getCircleSize: function() {
				//console.log(document.body.clientWidth / 60 + 'px')
				return document.body.clientWidth / 12
			},
			// deviceCharging: function() {
			// 	const _this = this;
			// 	return _this.data1.filter(obj => obj.WorkStatus == 2);
			// 	// _this.data1.forEach(function(x, index, a) {
			// 	// 	let type = '';
			// 	// 	switch (x.WorkStatus) {
			// 	// 		case 0:
			// 	// 			type = "空闲"
			// 	// 			break;
			// 	// 		case 1:
			// 	// 			type = "充电启动中"
			// 	// 			break;
			// 	// 		case 2:
			// 	// 			type = "充电中"
			// 	// 			break;
			// 	// 		case 6:
			// 	// 			type = "故障"
			// 	// 			break;
			// 	// 		case -1:
			// 	// 			type = "离线"
			// 	// 			break;
			// 	// 		default:
			// 	// 			type = "其他"
			// 	// 			break;
			// 	// 	}
			// 	// 	x.WorkStatus = type;
			// 	// });
			// 	// return _this.data1;
			// },
			// deviceStandby: function() {
			// 	const _this = this;
			// // 	_this.data2.forEach(function(x, index, a) {
			// // 		let type = '';
			// // 		switch (x.WorkStatus) {
			// // 			case 0:
			// // 				type = "空闲"
			// // 				break;
			// // 			case 1:
			// // 				type = "充电启动中"
			// // 				break;
			// // 			case 2:
			// // 				type = "充电中"
			// // 				break;
			// // 			case 3:
			// // 				type = "充电完成"
			// // 				break;
			// // 			case 4:
			// // 				type = "启动失败"
			// // 				break;
			// // 			case 6:
			// // 				type = "故障"
			// // 				break;
			// // 			case -1:
			// // 				type = "离线"
			// // 				break;
			// // 			default:
			// // 				type = "其他"
			// // 				break;
			// // 		}
			// // 		x.WorkStatus = type;
			// // 	});
			// // 	return _this.data2;
			// },
			pageParam: function() {
				const _this = this;
				const param = _this.formInline
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatorList: 'typeList',
			}),
			//当基础属性需要过率时候
			// ...mapGetters([
			// 	'getPageUserButton'
			// ])
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				//this.$refs.sonPage.getList();
				const _this = this
				const params = _this.formInline;
				params.page = 0;
				params.pageSize = 0;
				_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusBase', params).then(res => {
					if (res.data.code != 1) {
						_this.dataCharging = res.data.Data.List.filter((currentValue) => currentValue.WorkStatus === 2);

						// 充电中
						let idx = 0;
						_this.statusList[idx].statusDataTotal = _this.dataCharging = res.data.Data.List.filter((
							currentValue) => currentValue.WorkStatus == 2);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// 空闲
						idx++
						_this.statusList[idx].statusDataTotal = _this.dataStandby = res.data.Data.List.filter((
							currentValue) => {
							return currentValue.WorkStatus != 2 && currentValue.WorkStatus != 6 && currentValue.WorkStatus !=
								-1;
						});
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// 故障
						idx++;
						_this.statusList[idx].statusDataTotal = _this.dataFault = res.data.Data.List.filter((currentValue) =>
							currentValue.WorkStatus == 6);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// 离线
						idx++;
						_this.statusList[idx].statusDataTotal = _this.dataOffline = res.data.Data.List.filter((currentValue) =>
							currentValue.WorkStatus == -1);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));
						this.Summary = res.data.Data.Summary;
					}
				})
			},
			showMore(idx) {
				const _this = this;
				_this.statusList[idx].showNum += 20;
				_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this.statusList[idx]
					.showNum, _this.statusList[idx].statusDataTotal.length));
			},
			isAllShowed(idx) {
				const _this = this;
				return _this.statusList[idx].statusData.length == _this.statusList[idx].statusDataTotal.length;
			},
			detail: function(ConnectorNo, WorkStatus) {
				const _this = this
				const params = {
					ConnectorNo: ConnectorNo
				}
				_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusDetail', params).then(res => {
					if (res.data.code != 1) {
						_this.dataDetail = [];
						_this.dataDetail.push(res.data.Data.Detail);
					}
				})
				//充电中才会显示订单详情table
				if (WorkStatus == 2) {
					_this.tableShow = true
				} else {
					_this.tableShow = false
				}
				_this.showModel = true
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 300;
			},
			titleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "free cardTitleGreen"
						break;
					case 1:
						titleClass = "free cardTitleBlue"
						break;
					case 2:
						titleClass = "free cardTitleBlue"
						break;
					case 6:
						titleClass = "free cardTitleRed"
						break;
					case -1:
						titleClass = "free cardTitleGrey"
						break;
					default:
						titleClass = "free cardTitleGreen"
						break;
				}
				return titleClass;
			},
			circleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "#19be6b"
						break;
					case 1:
						titleClass = "#2d8cf0"
						break;
					case 2:
						titleClass = "#2d8cf0"
						break;
					case 6:
						titleClass = "#ed4e4c"
						break;
					case -1:
						titleClass = "#bbbbbb"
						break;
					default:
						titleClass = "#19be6b"
						break;
				}
				return titleClass;
			},
			// 圆形内的完整状态名（悬停提示用）
			workStatusFull: function(item) {
				return this.$tEnum('WorkStatus', item.WorkStatus, item.WorkStatusDesc)
			},
			// 圆形内显示的短写（没有短写时用完整名）
			workStatusShort: function(item) {
				return this.$tEnumShort('WorkStatus', item.WorkStatus, this.workStatusFull(item))
			},
			// 按文字长度自适应字号，保证塞进直径 72px 的圆里
			circleTextStyle: function(item) {
				const len = String(this.workStatusShort(item) || '').length
				let size = '1rem'
				if (len > 2 && len <= 4) size = '0.9rem'
				else if (len > 4 && len <= 6) size = '0.8rem'
				else if (len > 6 && len <= 9) size = '0.7rem'
				else if (len > 9) size = '0.6rem'
				// 去掉 circleTextColor 里的固定字号，再叠加自适应字号
				const colorStyle = this.circleTextColor(item.WorkStatus).replace(/font-size:[^;]*;?/g, '')
				return colorStyle + 'font-size:' + size +
					';line-height:1.15;text-align:center;word-break:break-word;max-width:54px;margin:0 auto;'
			},
			circleTextColor: function(WorkStatus) {
				let titleClass = 'font-size:1rem;';
				switch (WorkStatus) {
					case 0:
						titleClass += "color:#19be6b"
						break;
					case 1:
						titleClass += "color:#2d8cf0"
						break;
					case 2:
						titleClass += "color:#2d8cf0"
						break;
					case 6:
						titleClass += "color:#ed4e4c"
						break;
					case -1:
						titleClass += "color:#bbbbbb"
						break;
					default:
						titleClass += "color:#19be6b"
						break;
				}
				return titleClass;
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.col-24 {
		flex: 0 0 100%;
		max-width: 100%;
	}

	@media (min-width: 780px) {
		.col-md-12 {
			flex: 0 0 50%;
			max-width: 50%;
		}
	}

	@media (min-width: 1100px) {
		.col-lg-8 {
			flex: 0 0 33.33333333%;
			max-width: 33.33333333%;
		}
	}

	@media (min-width: 1420px) {
		.col-xxl-6 {
			flex: 0 0 25%;
			max-width: 25%;
		}
	}

	@media (min-width: 1740px) {
		.col-xxl-5 {
			flex: 0 0 20%;
			max-width: 20%;
		}
	}

	@media (min-width: 2060px) {
		.col-xxl-4 {
			flex: 0 0 16.66666666666667%;
			max-width: 16.66666666666667%;
		}
	}

	@media (min-width: 2380px) {
		.col-xxl-4 {
			flex: 0 0 14.285714285714%;
			max-width: 14.285714285714%;
		}
	}
	
	@media (min-width: 2700px) {
		.col-xxl-4 {
			flex: 0 0 12.5%;
			max-width: 12.5%;
		}
	}
	
	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.normal {
		margin-bottom: 20px;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 90% !important;
		height: 160px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	.normal .ivu-card-head {
		background-image: linear-gradient(#3FD983, #3aca79);
	}

	.normal .ivu-card-body {
		padding: 0px 10px;
	}

	.free {
		margin-bottom: 12px;
		box-shadow: 2px 2px 4px #a7a7a7;
		/* width: 90% !important; */
		height: 150px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	.free .ivu-card-body {
		padding: 0px 10px;
	}

	.cardTitleBlue .ivu-card-head {
		background-image: linear-gradient(#4d9ae7, #55aaff);
	}

	.cardTitleRed .ivu-card-head {
		background-image: linear-gradient(#ed4e4c, #ed7f7c);
	}

	.cardTitleGrey .ivu-card-head {
		background-image: linear-gradient(#bbbbbb, #dddddd);
	}

	.cardTitleGreen .ivu-card-head {
		background-image: linear-gradient(#19be6b, #4ad697);
	}

	.ivu-card-head p {
		text-align: left;
		color: white;
	}

	.freeDiv {
		text-align: center;
		height: 100px;
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.freeDiv .ivu-chart-circle-inner {
		/* top: 1.1875rem; */
	}

	.ivu-chart-circle-inner p {
		font-size: 0.46875rem;
	}

	.chargeCardClass .ivu-col-span-7 {
		margin-left: 0px;
	}

	.ivu-chart-circle {
		/* width: 2.8125rem !important; */
		/* height: 2.8125rem !important; */
	}

	.circle-div {
		float: left;
		width: 22%;
		height: 100%;
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 1rem;
	}

	.statusCard {
		font-size: 0.75rem;
		width: 78%;
		float: right;
		height: 100px;
		padding: 0px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex: 1;
	}

	.tag {
		background-color: #2d8cf0;
		padding: 0px 2px 0px 2px;
		border-radius: 2px;
	}

	.label {
		background: transparent !important;
		padding-left: 0;
	}

	.label .ivu-tag-dot-inner {
		margin-right: 0;
		height: 15px;
		width: 15px;
	}

	.label .ivu-tag-text {
		font-size: 20px;
	}

	.loginBg .ivu-card-bordered,
	.ivu-card {
		margin-right: 0;
	}
</style>
